// extracted by mini-css-extract-plugin
module.exports = {"chooser":"ProjectChooser_chooser__2lqS0","chooser__item":"ProjectChooser_chooser__item__1Ay6r","chooser__item_active":"ProjectChooser_chooser__item_active__2ppop"};